export const UNAUTHORIZED = "UNAUTHORIZED";
export const BAD_CREDENTIALS = "BAD_CREDENTIALS";
